import { Bubble } from 'js/bubbleCore/bubbles/types';
import { ISpace, clamp } from 'framework/utils/math-utils';
import { IHexSpaceData } from 'js/bubbleCore/types';
import {
  IEvent,
  Wall,
  createBubbleUpdatedEvent,
  createBubbleSpaceLimitCollisionEvent,
} from 'js/bubbleCore/events';

// interface IPositionProps {
//   hexSpaceX: number;
//   hexSpaceY: number;
//   velX: number;
//   velY: number;
// }

export function updatePositionInSpace<T>(
  bubble: Bubble,
  space: IHexSpaceData<T>,
  events?: IEvent[],
): void {
  bubble.velY += space.gravity;

  const orgX = bubble.hexSpaceX;
  const orgY = bubble.hexSpaceY;

  bubble.hexSpaceX += bubble.velX;
  bubble.hexSpaceY += bubble.velY;

  const {left, right, top, bottom } = space.limits;

  if (bubble.hexSpaceX <= left || bubble.hexSpaceX >= right) {
    const offset = bubble.hexSpaceX < left ? left - bubble.hexSpaceX : right - bubble.hexSpaceX;

    if (events) {
      events.push(
        createBubbleSpaceLimitCollisionEvent(
          bubble,
          bubble.hexSpaceX <= left ? Wall.Left : Wall.Right,
          {x: bubble.hexSpaceX <= left ? left : right, y: bubble.hexSpaceY}
        )
      );
    }

    bubble.velX = bubble.velX * -1;
    bubble.hexSpaceX = clamp(bubble.hexSpaceX, left, right) + offset;
  }

  if (bubble.hexSpaceY < top || bubble.hexSpaceY >= bottom) {

    if (events) {
      events.push(
        createBubbleSpaceLimitCollisionEvent(
          bubble,
          bubble.hexSpaceY <= top ? Wall.Top : Wall.Bottom,
          {x: bubble.hexSpaceX, y: bubble.hexSpaceY <= top ? top : bottom}
        )
      );
    }

    bubble.velY = bubble.velY * -1;
    bubble.hexSpaceY = clamp(bubble.hexSpaceY, top, bottom);
  }

  if (events) events.push(createBubbleUpdatedEvent(bubble));
}

